import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';

export default function StripeChargeModalProfilePhoto({ photoUrl }) {
  return (
    <div className="h0 tc">
      <div className="StripeChargeModal__profilePhoto f0">
        <SmartImage
          Tag="div"
          src={photoUrl}
          width="88px"
          height="88px"
          className="br-100 ba bw2 b--white shadow-1 bg-center cover"
          loadingClass="bg-white"
          imageOnlyClassName="ba"
          crop
        />
      </div>
    </div>
  );
}

StripeChargeModalProfilePhoto.propTypes = {
  photoUrl: PropTypes.string
};

StripeChargeModalProfilePhoto.defaultProps = {
  photoUrl: null
};
